<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin About Page</span>
        <h1>Manage about page content.</h1>
        <p>Hero, company profile, features and company journey timeline.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div *ngIf="loading">Loading about data...</div>

        <div *ngIf="successMessage" class="alert success" style="margin-bottom:16px">
            {{ successMessage }}
        </div>

        <div *ngIf="errorMessage" class="alert error" style="margin-bottom:16px">
            {{ errorMessage }}
        </div>

        <div class="contact-grid" style="margin-bottom:28px">

            <main class="quote-panel">
                <span class="section-kicker">About Hero</span>
                <h2 style="font-size:32px;margin-top:8px">Hero section</h2>

                <div class="form-grid">
                    <div class="field full">
                        <label>Eyebrow</label>
                        <input [(ngModel)]="hero.eyebrow" name="aboutEyebrow">
                    </div>

                    <div class="field full">
                        <label>Title</label>
                        <input [(ngModel)]="hero.title" name="aboutTitle">
                    </div>

                    <div class="field full">
                        <label>Description</label>
                        <textarea [(ngModel)]="hero.description" name="aboutDescription"></textarea>
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="hero.status" name="aboutHeroStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full">
                        <button class="btn btn-primary" type="button" (click)="saveHero()" [disabled]="saving">
                            Save Hero
                        </button>
                    </div>
                </div>
            </main>

            <aside class="quote-panel">
                <span class="section-kicker">Company Profile</span>
                <h2 style="font-size:32px;margin-top:8px">Profile section</h2>

                <div class="form-grid" style="grid-template-columns:1fr">
                    <div class="field">
                        <label>Kicker</label>
                        <input [(ngModel)]="profile.kicker" name="profileKicker">
                    </div>

                    <div class="field">
                        <label>Title</label>
                        <input [(ngModel)]="profile.title" name="profileTitle">
                    </div>

                    <div class="field">
                        <label>Description</label>
                        <textarea [(ngModel)]="profile.description" name="profileDescription"></textarea>
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="profile.status" name="profileStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field">
                        <button class="btn btn-primary" type="button" (click)="saveProfile()" [disabled]="saving">
                            Save Profile
                        </button>
                    </div>
                </div>
            </aside>

        </div>

        <div class="contact-grid">
            <main class="quote-panel">
                <span class="section-kicker">About Items</span>
                <h2 style="font-size:32px;margin-top:8px">
                    {{ itemModel.id === 0 ? 'New Item' : 'Edit Item' }}
                </h2>

                <div class="cert-filter-bar" style="margin:16px 0">
                    <button type="button"
                            [class.active]="selectedType === 'features'"
                            (click)="changeType('features')">
                        Features
                    </button>

                    <button type="button"
                            [class.active]="selectedType === 'timeline'"
                            (click)="changeType('timeline')">
                        Timeline
                    </button>
                </div>

                <div class="form-grid">

                    <div class="field" *ngIf="isTimeline()">
                        <label>Year / Stage</label>
                        <input [(ngModel)]="itemModel.year" name="timelineYear" placeholder="2003">
                    </div>

                    <div class="field" *ngIf="isTimeline()">
                        <label>Tag</label>
                        <input [(ngModel)]="itemModel.tag" name="timelineTag" placeholder="Foundation">
                    </div>

                    <div class="field full">
                        <label>Title</label>
                        <input [(ngModel)]="itemModel.title" name="aboutItemTitle">
                    </div>

                    <div class="field full">
                        <label>Description</label>
                        <textarea [(ngModel)]="itemModel.description" name="aboutItemDescription"></textarea>
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="itemModel.sort" name="aboutItemSort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="itemModel.status" name="aboutItemStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveItem()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Item' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newItem()">
                            Clear
                        </button>
                    </div>
                </div>
            </main>

            <aside>
                <span class="section-kicker">Current Items</span>
                <h2 style="font-size:34px">{{ selectedType }}</h2>

                <div class="office-card premium-office" *ngFor="let item of getItems()">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.description }}</p>
                    <span>
                        {{ item.year || item.tag || '' }}
                        {{ item.status ? 'Active' : 'Hidden' }}
                        / Sort {{ item.sort }}
                    </span>

                    <div style="display:flex;gap:8px;margin-top:14px">
                        <button class="btn btn-ghost" type="button" (click)="editItem(item)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteItem(item)">
                            Delete
                        </button>
                    </div>
                </div>

                <div *ngIf="getItems().length === 0" style="padding:20px 0">
                    No items found.
                </div>
            </aside>
        </div>

    </div>
</section>